import React from 'react'
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import {faTimes} from '@fortawesome/free-solid-svg-icons'

export const CloseIcon = ({onClick = undefined}) => <FontAwesomeIcon onClick={onClick} icon={faTimes} />

export default CloseIcon
